
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Dreimal pro Woche etwa 45 Minuten lang mit einem Pulsziel von 120 bis 140
Herzschlägen pro Minute, rät die Schweizerische Kopfwehgesellschaft. Und dazu
tägliche Entspannungsübungen. Weshalb Ausdauersport genau hilft, ist nicht
vollständig geklärt. Es wird vermutet, dass es mit dem Einfluss von Sport auf
die Mitochondrien in den Zellen zu tun hat. Mitochondrien versorgen die Zellen
mit Energie.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;